var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4256_2349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9223 15.082C14.8278 14.8614 16.6999 14.4217 18.5 13.772C16.9756 12.1208 16.1332 9.9745 16.1366 7.75V7C16.1366 5.4087 15.4901 3.88258 14.3394 2.75736C13.1886 1.63214 11.6279 1 10.0005 1C8.37312 1 6.81239 1.63214 5.66165 2.75736C4.51091 3.88258 3.86443 5.4087 3.86443 7V7.75C3.86752 9.97463 3.0248 12.121 1.5 13.772C3.2723 14.412 5.14074 14.857 7.07872 15.082M12.9223 15.082C10.9812 15.3071 9.01978 15.3071 7.07872 15.082M12.9223 15.082C13.0697 15.5319 13.1063 16.0094 13.0293 16.4757C12.9522 16.942 12.7636 17.384 12.4789 17.7656C12.1941 18.1472 11.8212 18.4576 11.3905 18.6716C10.9599 18.8856 10.4836 18.9972 10.0005 18.9972C9.51742 18.9972 9.04116 18.8856 8.61049 18.6716C8.17983 18.4576 7.80694 18.1472 7.52217 17.7656C7.23741 17.384 7.04882 16.942 6.97176 16.4757C6.8947 16.0094 6.93134 15.5319 7.07872 15.082",
    stroke: "#474F63",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4256_2349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.4c319c420a33ede2f208008918f928a5.svg";
export { ForwardRef as ReactComponent };